
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 23 18.549"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.731 18.049a.548.548 0 00.115-.013l4.92-1.074a13.4 13.4 0 004.68.84h.056c6.064 0 11-3.881 11-8.651s-4.934-8.65-11-8.65-11 3.88-11 8.65v.006a7.414 7.414 0 001.744 4.68l-1.02 3.559a.506.506 0 00.125.493.535.535 0 00.38.16zm-.7-8.9h0z","fill":"none","stroke":"#2684ff"}}),_c('path',{attrs:{"d":"M10.724 11.771a1.032 1.032 0 01-1.461 0l-1.59-1.586a1.035 1.035 0 011.464-1.463l.857.857 3.479-3.48a1.034 1.034 0 011.459 1.465z","fill":"#2684ff","stroke":"#f3f8ff"}})])
          )
        }
      }
    